<template>
  <a-modal
    v-model:open="visable"
    :title="titleText"
    destroyOnClose
    :maskClosable="false"
    :footer="null"
    wrapClassName="group-expire-pop important-popup"
    :width="400"
    centered
    :afterClose="onClose"
  >
    <div class="modal-body">
      <div class="content-box">
        <div v-if="isSuperAdmin" class="content-box-admin">
          <div class="content-box-admin-top">
            <div class="content-box-teamNickname">{{ userStore.userInfo.teamNickname + ", 您好" }}</div>
            <div>您管理的团队版会员套餐已过期</div>
          </div>
          <div class="content-box-card">
            <div>• 所有成员的历史创作素材已妥善保留</div>
            <div>• 模型系统和配置数据完整保存</div>
            <div>• 续费后团队可立即恢复正常使用</div>
          </div>
          <div>立即续费让团队继续高效协作。</div>
        </div>
        <div class="content-box-desc" v-else>
          <div>💡 温馨提示</div>
          <div class="content-box-card">
            <div>• 套餐过期不影响数据安全，所有内容都已为您保留</div>
            <div>• 续费后无需重新配置，请联系管理员选择套餐即刻恢复使用</div>
            <div>• 如有疑问，请联系客服获取帮助</div>
          </div>
        </div>
      </div>
      <div class="footer-box">
        <div v-if="isSuperAdmin" class="pay-button" @click="onPayButton">立即续费</div>
        <div v-else class="primary-button" @click="onCloseButton">知道了</div>
      </div>
    </div>
  </a-modal>
</template>

<script setup lang="ts">
/**store start */
import useGroupStore from "@/store/group";
import { useTeamEditionStore } from "@/store/teamEdition";
import { useUserStore } from "@/store/user";
/**store end */

import { storeToRefs } from "pinia";
import { computed, onMounted, ref } from "vue";

interface Props {
  onClose: () => void;
}

defineProps<Props>();
const modalId = "group-expire-pop";
defineOptions({ modalId });

const groupStore = useGroupStore();
const userStore = useUserStore();
const teamEditionStore = useTeamEditionStore();

const { isSuperAdmin } = storeToRefs(groupStore);

const titleText = computed(() => (isSuperAdmin.value ? `团队版会员套餐已过期` : `当前团队套餐已过期`));

const visable = ref(false);

onMounted(() => {
  visable.value = true;
});

const onCloseButton = () => {
  visable.value = false;
};

const onPayButton = async () => {
  teamEditionStore.handleOpenTeamEdition();
  visable.value = false;
};
</script>

<style scoped lang="less">
.modal-body {
  display: flex;
  flex-direction: column;
  gap: 40px;
  .content-box {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .content-box-admin {
      display: flex;
      flex-direction: column;
      gap: 16px;
      color: rgba(236, 233, 242, 0.9);
      font-size: 14px;
      font-weight: 400;
      line-height: 20px; /* 142.857% */
      padding-bottom: 72px;
      .content-box-admin-top {
        display: flex;
        flex-direction: column;
        gap: 8px;

        .content-box-teamNickname {
          color: #fff;
          font-size: 14px;
          font-weight: 600;
          line-height: 20px; /* 142.857% */
        }
      }
    }
    .content-box-card {
      display: flex;
      flex-direction: column;
      padding: 20px 16px;

      gap: 16px;
      border-radius: 12px;
      background: rgba(235, 235, 245, 0.08);
      color: #fff;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px; /* 142.857% */
    }
    .content-box-desc {
      display: flex;
      flex-direction: column;
      gap: 16px;
      padding-bottom: 116px;

      color: rgba(236, 233, 242, 0.9);
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }
  }

  .footer-box {
    display: flex;
    width: 100%;

    .pay-button {
      display: flex;
      padding: 10px 40px;
      justify-content: center;
      align-items: center;
      gap: 12px;
      width: 100%;
      border-radius: 10px;
      border: 1px solid rgba(235, 235, 245, 0.15);
      background: #f4d1b4;
      cursor: pointer;
      color: #000;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px; /* 142.857% */
    }

    .primary-button {
      width: 100%;
      display: flex;
      padding: 10px 40px;
      justify-content: center;
      align-items: center;
      gap: 12px;
      border-radius: 10px;
      border: 1px solid rgba(235, 235, 245, 0.15);
      background: #8c5bec;
      height: auto;
      cursor: pointer;
    }
  }
}
</style>

<style lang="less">
.group-expire-pop {
  .ant-modal-content {
    border-radius: 38.4px;
    border: 1px solid rgba(235, 235, 245, 0.08);
    background: #424248;
    padding: 0px;

    .ant-modal-close {
      top: 24px;
      right: 24px;
    }
  }

  .ant-modal-header {
    background: transparent;
    margin: 0px;
  }
  .ant-modal-title {
    display: flex;
    justify-content: center;
    padding: 24px 24px 0px 24px;
    align-items: center;
    gap: 12px;
    align-self: stretch;
    background-color: transparent;
    color: #fff;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px; /* 140% */
    letter-spacing: -0.6px;
  }

  .ant-modal-body {
    padding: 24px; /* 统一由 .modal-body 控制内边距 */
    padding-top: 40px;
  }
}
</style>
